import { createFileRoute } from '@tanstack/react-router';
import { packageStaticData } from '../package';

export const Route = createFileRoute('/_private-routes/package/')({
  staticData: packageStaticData
});
